import { Box } from "@mui/material";
import { LoginBg } from "../../assets";
import { useEffect, useState } from "react";
import { ForgotPassword } from "./ForgotPassword";
import { Login } from "./login";
import { OtpLogin } from "./OtpLogin";
import styled from "@emotion/styled";
import { useLocation } from "react-router-dom";

export const CustomBox = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  flexDirection: "column",
  minHeight: "100svh",
  backgroundSize: "cover !important",
  backgroundRepeat: "no-repeat",
  backgroundColor: "#002045 !important",
  background: `url(${LoginBg})`,
  [theme.breakpoints.down("sm")]: {
    background: "none",
  },
}));

export const LoginContainer = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  [theme.breakpoints.down("sm")]: {
    width: "100%",
    padding: theme.spacing(1, 2.5),
  },
  [theme.breakpoints.down("md")]: {
    padding: theme.spacing(1, 2.5),
  },
}));

export const Register = () => {
  const hostname = window.location.hostname;
  const isCustomerApp = hostname === "customer.finhub.habilelabs.io";

  const location = useLocation();
  const [showForgotPassword, setShowForgotPassword] = useState(false);
  const [showOtpLogin, setShowOtpLogin] = useState(false);

  // Global cleanup on first load
  useEffect(() => {
    sessionStorage.removeItem("isLogged");
    sessionStorage.clear();
    localStorage.clear();
    window.history.replaceState({}, "", "/login");
  }, []);

  // React to router state updates
  useEffect(() => {
    if (location?.state?.showForgotPassword) {
      setShowForgotPassword(true);
    }
  }, [location.state]);

  // Handlers
  const handleBackLogin = () => {
    setShowForgotPassword(false);
    setShowOtpLogin(false);
  };

  const handleForgotPassword = () => {
    setShowForgotPassword(true);
    setShowOtpLogin(false);
  };

  const handleOtpOrMagicLink = () => {
    setShowOtpLogin(true);
    setShowForgotPassword(false);
  };

  // Customer UI (OTP only)
  const CustomerLoginUI = () => (
    <CustomBox>
      <LoginContainer>
        <OtpLogin />
      </LoginContainer>
    </CustomBox>
  );

  // Main UI (Full login flow)
  const MainLoginUI = () => (
    <CustomBox>
      <LoginContainer>
        {showForgotPassword ? (
          <ForgotPassword handleBackLogin={handleBackLogin} />
        ) : showOtpLogin ? (
          <OtpLogin handleBackLogin={handleBackLogin} />
        ) : (
          <Login
            handleForgotPassword={handleForgotPassword}
            handleOtpOrMagicLink={handleOtpOrMagicLink}
          />
        )}
      </LoginContainer>
    </CustomBox>
  );

  return isCustomerApp ? <CustomerLoginUI /> : <MainLoginUI />;
};
